import { getOrpcClient } from "@-/dev.improve.haniverse.lib.orpc";
import { withDeadline } from "@-/dev.improve.haniverse.lib.deadline";

export function connectActorAutoSync(_options: {
  loadFromCloud: () => Promise<unknown>;
  onError: (error: unknown) => void;
  userId: string;
}) {
  return () => {};
}

/** One small oRPC request; it only nudges other devices, so it never waits past a network bound. */
const NOTIFY_DEADLINE_MS = 20_000;

export async function notifyActorSync(): Promise<void> {
  await withDeadline({ deadline: NOTIFY_DEADLINE_MS, operation: "sync.notify" }, () =>
    getOrpcClient.sync.notify(),
  );
}
